<script>
import NavMenuItem from "./items/navMenuItem";
const defaultData1 = [
  {
    _id: 1,
    imgUrl: "",
    icon: "icon-location-solid",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "坐标",
    url: "",
  },
  {
    _id: 2,
    imgUrl: "",
    icon: "icon-xiaolianmanyifuwu",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "笑脸",
    url: "",
  },
  {
    _id: 3,
    imgUrl: "",
    icon: "icon-tab-addressbook-fill",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "通讯录",
    url: "",
  },
  {
    _id: 4,
    imgUrl: "",
    icon: "icon-tab_message_d",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "消息中心",
    url: "",
  },
  {
    _id: 5,
    imgUrl: "",
    icon: "icon-location-solid",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "坐标",
    url: "",
  },
  {
    _id: 6,
    imgUrl: "",
    icon: "icon-xiaolianmanyifuwu",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "笑脸",
    url: "",
  },
  {
    _id: 7,
    imgUrl: "",
    icon: "icon-tab-addressbook-fill",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "通讯录",
    url: "",
  },
  {
    _id: 8,
    imgUrl: require('_platform/assets/styles/themes/img/banner-demo1.png'),
    icon: "icon-tab_message_d",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "消息中心",
    url: "",
  },
  {
    _id: 9,
    imgUrl: "",
    icon: "icon-tab_message_d",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "消息中心",
    url: "",
  },
];
const defaultData2 =[
  {
    _id: 1,
    imgUrl: "",
    icon: "icon-location-solid",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "分组1",
    url: "",
    children: defaultData1
  },
  {
    _id: 2,
    imgUrl: "",
    icon: "icon-xiaolianmanyifuwu",
    backgroundColor: "",
    foreColor: "",
    openType: "1",
    name: "分组2",
    url: "",
    children: defaultData1
  },
];

export default dsf.component({
  name: "DsfNavMenu",
  mixins: [$mixins.control],
  ctrlCaption: "快捷菜单",
  design: {
    isMask: false,
  },
  components: {
    NavMenuItem,
  },
  props: {
    // 分组形式：none 不分组、tile 平铺、tab 按钮切换
    groupModel: {
      type: String,
      default: "none",
    },
    // 一行几列
    colNum: {
      type: Number,
      default: 5,
    },
    // 一页几行
    // 0表示不限行数，且页数将固定1
    rowNum: {
      type: Number,
      default: 0,
    },
    // 最多几页
    // 0表示无限制
    maxPages: {
      type: Number,
      default: 0,
    },
    // 组件高度
    height: {
      type: String,
      default: "100%",
    },
    // 组件最小高度
    minHeight: {
      type: String,
      default: "130px",
    },
    // 是否显示轮播切换箭头
    arrow: {
      type: Boolean,
      default: false,
    },
    // 是否强制使用默认样式
    useDefaultStyle: {
      type: Boolean,
      default: false,
    },
    // 是否显示更多按钮
    hasMore: {
      type: Boolean,
      default: false,
    },
    /*****更多按钮*****/
    // 更多按钮显示文字
    moreText: {
      type: String,
      default: "更多",
    },
    // 更多按钮显示图标
    moreIcon: {
      type: String,
      default: "icon-quanbu",
    },
    // 更多按钮跳转链接
    moreUrl: {
      type: String,
      default: "",
    },
    // 更多按钮跳转方式
    moreOpentype: {
      type: String,
      default: "0",
    },
    /*****样式*****/
    // 鼠标特效
    hoverAnimation: {
      type: String,
      default: "-",
    },
    // 默认图标
    defaultIcon: {
      type: String,
      default: "icon-icon_yingyongguanli",
    },
    // 展示优先级。img图片优先，icon图标优先
    showPriority: {
      type: String,
      default: "img",
    },
    menuHasBg: {
      type: Boolean,
      default: true,
    },
    menuBgColor: {
      type: String,
      default: "#fff",
    },
    menuBgShadow: {
      type: Boolean,
      default: true,
    },
    menuColor: {
      type: String,
      default: "theme",
    },
    menuShadow: {
      type: Boolean,
      default: true,
    },
    menuBorderRadius: {
      type: String,
      default: "5px",
    },
    menuBorderSize: {
      type: String,
      default: "50px",
    },
    menuIconSize: {
      type: String,
      default: "30px",
    },
    // 按钮尺寸
    menuBtSize: {
      type: String,
      default: "100px",
    },
    // 按钮圆角
    menuBtRadius: {
      type: String,
      default: "5px",
    },
    // 数据来源
    dataSource: {
      type: String,
      default: "http",
    },
    dataSourceUrl: {
      type: String,
      default: "",
    },
    dataSourceList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 二次开发传入的方法。
    itemClick: {
      type: Function,
      required: false,
    },
    clickBefore: {
      type: Function,
      required: false,
    },
  },
  data() {
    this.__wheelDeltaStart = 0;
    return {
      // 请求状态
      loading: false,
      activeIndex: 0,
      isLoading: true,
      data: [],
    };
  },
  computed: {
    ...Vuex.mapState("cornerMark", ["badges", "menuIds"]),
    dataList() {
      if (this.isDesign) {
        if (this.dataSource == "http" || !this.dataSourceList.length) {
          return this.groupModel == 'none' ? defaultData1 : defaultData2;
        }
      }
      if (this.dataSource == "http") {
        return this.data;
      }
      return this.dataSourceList;
    },
    rootClass() {
      let res = ['dsf-control ds-nav-menu', this.hoverAnimation];
      if (this.menuHasBg) {
        res.push("hasBg");
        if (this.menuBgColor == "theme") {
          res.push("bgTheme");
        }
      }
      if (this.menuBgShadow) {
        res.push("bgShadow");
      }
      if (this.menuShadow) {
        res.push("iconShadow");
      }
      if (this.menuColor == "theme") {
        res.push("iconTheme");
      }
      if (this.arrow && this.pages > 1) {
        res.push("arrow");
      }
      return res;
    },
    rootStyle() {
      let res = { "min-height": this.minHeight };
      if (this.isDesign) {
        this.$dispatch("design-height-change", this.height);
        res.height = "100%";
      } else {
        res.height = this.height;
      }
      return res;
    },
    itemStyle() {
      let w = (100 / this.colNum).toFixed(2) + "%";
      return {
        width: w,
        flex: "0 0 " + w,
      };
    },
    itemBgStyle() {
      let res = {
        width: this.menuBorderSize,
        height: this.menuBorderSize,
        "border-radius": this.menuBorderRadius,
      };
      if (this.menuHasBg && this.menuBgColor != "theme") {
        res["background-color"] = this.menuBgColor;
      }
      return res;
    },
    itemBtStyle() {
      return {
        width: this.menuBtSize,
        height: this.menuBtSize,
        "border-radius": this.menuBtRadius,
      };
    },
    itemIconStyle() {
      let res = {
        "font-size": this.menuIconSize,
      };
      // if (this.menuColor != "theme") {
      res["color"] = this.menuColor;
      // }
      return res;
    },
    // 页数
    pages() {
      let {groupModel, rowNum, dataList, pageSize, maxPages} = this;
      let fn = (list) => {
        if (!rowNum) {
          return 1;
        }
        let pages = Math.ceil(list.length / pageSize);
        if (!maxPages) {
          return pages;
        }
        return Math.min(maxPages, pages);
      }
      if (groupModel == 'tile' || groupModel == 'tab') {
        return _.map(dataList, item => fn(item.children || []));
      }
      return fn(dataList);
    },
    // 一页几个
    pageSize() {
      return (this.colNum || 1) * this.rowNum;
    },
    moreInfo() {
      if (!this.hasMore || this.loading) return {};
      return {
        _id: "more",
        imgUrl: "",
        icon: this.getIcon(this.moreIcon),
        color: "",
        bgColor: "",
        url: this.moreUrl,
        openType: this.moreOpentype,
        name: this.moreText,
      };
    },
    menuList() {
      let {groupModel, rowNum, dataList, moreInfo, pageSize, pages} = this;
      let fn = (list, pages) => {
        let res = [];
        if (!rowNum) {
          res = this.hasMore ? [[...list, moreInfo]] : [list];
        } else {
          for (let i = 0; i < pages; i++) {
            res.push(list.slice(i * pageSize, i * pageSize + pageSize));
          }
          if (!res.length) {
            res = [[]];
          }
          if (this.hasMore) {
            let lastItem = res.length - 1 < 0 ? null : _.last(res);
            if (lastItem) {
              if (this.maxPages == res.length && lastItem.length == pageSize) {
                lastItem.pop();
              }
              lastItem.push(moreInfo);
            } else {
              res.push([moreInfo]);
            }
          }
        }
        // 补位
        let lastPage = _.last(res);
        if (rowNum && lastPage.length < pageSize) {
          for (let i = 0, l = pageSize - lastPage.length; i < l; i++) {
            lastPage.push({
              id: dsf.uuid(8),
              hide: true,
            });
          }
        }
        return res;
      }
      if (groupModel == 'tile' || groupModel == 'tab') {
        return _.map(dataList, (item, i) => {
          return {
            ...item,
            children: fn(item.children || [], pages[i])
          }
        });
      }
      return fn(dataList, pages);
    },
  },
  watch: {
    dataSourceUrl() {
      this.init();
    },
    dataList(newD, oldD) {
      if (newD && newD.length > 0) {
        this.getCornerMarkInfo(newD); //获取角标
      }
    },
  },
  render(h) {
    let {groupModel, menuList, pages, rootClass, rootStyle} = this;
    let childrenVNodes = [];
    if (groupModel == 'tile') {
      childrenVNodes = this.getTileRender(h, menuList, pages);
    } else if (groupModel == 'tab') {
      childrenVNodes = [];
    } else {
      childrenVNodes = this.getGroupRender(h, menuList, pages);
    }
    return (<div class={rootClass} style={rootStyle}>{childrenVNodes}</div>);
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    clearTimeout(this.__timeout);
  },
  methods: {
    getTileRender(h, groupList, pages) {
      let vNodes = _.map(groupList, (group, i) => {
        return (<div class="ds-nav-menu-section">
          <dsf-title value={group.name} fontType={4} show-color-lump show-weight />
          <div class="ds-nav-menu-section-content">
            { this.getGroupRender(h, group.children, pages[i]) }
          </div>
        </div>)
      });
      return vNodes;
    },
    getTabRender(h, groupList) {},
    getGroupRender(h, groupData, pages) {
      let {arrow, activeIndex, minHeight} = this;
      if (pages == 1) {
        return this.getPageRender(h, groupData[0]);
      }
      if (groupData.length > 1) {
        let items = _.map(groupData, menu => {
          return (<el-carousel-item>
            <dsf-virtual-scroll>
              {this.getPageRender(h, menu)}
            </dsf-virtual-scroll>
          </el-carousel-item>);
        });
        let childrenVNodes = [(<el-carousel
          ref="carousel" style={{ 'min-height': minHeight }} loop={false} autoplay={false}
          arrow="never" nativeOn={{wheel: this.onWheel}} on={{change: (e) => this.activeIndex = e}}>
          {items}
        </el-carousel>)];
        if (arrow) {
          let classLeft = ['ds-nav-menu-arrow', 'left'];
          if (activeIndex == 0) classLeft.push('disabled');
          let classRight = ['ds-nav-menu-arrow', 'right'];
          if (activeIndex == groupData.length - 1) classRight.push('disabled');
          childrenVNodes.push(
            (<div class={classLeft}>
              <i class="iconfont icon-arrow-left2" on={{click: () => this.$refs.carousel.prev()}}></i>
            </div>),
            (<div class={classRight}>
              <i class="iconfont icon-arrow-right2" on={{click: () => this.$refs.carousel.next()}}></i>
            </div>)
          );
        }
        return childrenVNodes;
      }
      return [];
    },
    getPageRender(h, pageData) {
      let {badges} = this;
      let vNodes = _.map(pageData, item => {
        let badge = badges[item["id"]] && badges[item["id"]]["num"];
        let badgeVNode = item['mark_type'] ? (
          <div slot="badge" class="ds-aside-menu-item-box badgeBox" v-show={badge}>
            <span class="ds-page-home-badge text">{badge}</span>
          </div>
        ) : '';
        return (<nav-menu-item key={item._id} item={item}>
          { badgeVNode }
        </nav-menu-item>);
      });
      return (<div class="ds-nav-menu-group">{vNodes}</div>);
    },
    getCornerMarkInfo(lists) {
      let cornerMarkInfo = {
        markTypes: [], //建立链接的类型
        menu_ids: [], //菜单主键id
      };
      _.forEach(lists, list => {
        // 类型
        let mark_type = list.mark_type;
        let markTypes = cornerMarkInfo.markTypes;
        let id = list.id;
        if (mark_type && !this.menuIds.includes(id)) {
          cornerMarkInfo.menu_ids.push(id);
          if (!markTypes.includes(mark_type)) {
            markTypes.push(mark_type);
          }
        }
      });
      let markTypes = cornerMarkInfo.markTypes;
      if (markTypes.length) {
        this.$http
          .get("cornerMark/getMarkIdList", { markTypes: markTypes.join(",") })
          .done(res => {
            if (res.success) {
              this.$store.dispatch("cornerMark/init", {
                markId: res.data,
                menu_ids: cornerMarkInfo.menu_ids,
                type: "DsfNavMenu",
              });
            }
          })
          .error(res => {
            dsf.layer.message(res?.message || "根据菜单类型获取所有角标业务ID异常", false);
          });
      }
    },
    reloadData() {
      this.init();
    },
    init() {
      if (this.isDesign || this.dataSource != "http") {
        return;
      }
      if (this.dataSourceUrl == "") {
        this.data = [];
        return;
      }
      this.loading = true;
      this.$http
        .get(this.dataSourceUrl)
        .done(({ success, data, message }) => {
          if (success) {
            this.data = data;
            this.loading = false;
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error(err => {
          dsf.layer.message(err.message, false);
        })
        .always(() => {
          this.isLoading = false;
        });
    },
    _clickBefore(next, ...params) {
      if (this.isDesign) return;
      let res = this.clickBefore?.(...params);
      if (res && res.then) {
        res.then(r => {
          if (r !== false) {
            next(...params);
          }
        });
      } else if (res !== false) {
        next(...params);
      }
    },
    onClick(item) {
      if (this.itemClick) {
        let res = this.itemClick(item);
        if (res === false) return;
        if (res.then) {
          res.then(r => {
            if (r !== false) {
              this.openPage(item);
            }
          });
          return;
        }
      }
      this.openPage(item);
    },
    getImgUrl({ imgUrl, icon }) {
      if (this.showPriority == "img") {
        return imgUrl;
      }
      if (!icon || icon == "") {
        return imgUrl;
      }
      return "";
    },
    getItemStyle({ backgroundColor }) {
      if (this.useDefaultStyle || !this.menuHasBg) {
        return {};
      }
      if (backgroundColor) {
        return {
          background: backgroundColor,
        };
      }
      return {};
    },
    getIconStyle({ foreColor }) {
      if (this.useDefaultStyle) {
        return {};
      }
      if (foreColor) {
        return {
          color: foreColor,
        };
      }
      return {};
    },
    getIcon(icon) {
      if (!icon || icon == "") {
        icon = this.defaultIcon || "icon-icon_yingyongguanli";
      }
      if (!icon) return "";
      return `${icon} icon-${icon}`;
    },
    openPage(menu) {
      let url = menu.url;
      if (!url || url == "") {
        return;
      }
      if (url.indexOf("#") == 0 && url.indexOf("#/") != 0) {
        url = url.replace("#", "#/");
      }
      url = this.$replace(url, this.local);
      let opt = {
        url,
        state: menu.openType || menu.opentype,
      };
      if (opt.state == 3) {
        opt["title"] = menu.dialogTitle || menu.name || undefined;
        opt["width"] = menu.dialogWidth || "70vw";
        opt["height"] = menu.dialogHeight || "60vh";
      }
      this.$open(opt);
    },
    // 滚轮翻页
    onWheel(e) {
      let deltaX = e.deltaX * -1,
        deltaY = e.deltaY * -1;
      if (e.shiftKey && deltaY) {
        deltaX = deltaY;
        deltaY = 0;
      }
      if (dsf.client.type === "FF" && e.deltaMode === 1) {
        if (deltaX) deltaX = deltaX < 0 ? -100 : 100;
        if (deltaY) deltaY = deltaY < 0 ? -100 : 100;
      }
      let delta = deltaY || deltaX;
      if ((delta > 0 && this.lastDelta < 0) || (delta < 0 && this.lastDelta > 0)) {
        this.__wheelDeltaStart = 0;
        this.lastDelta = delta;
      }
      clearTimeout(this.__timeout);
      this.__wheelDeltaStart += delta;
      let offset = delta - this.__wheelDeltaStart;
      if ((offset < 0 && this.activeIndex > 0) || (offset > 0 && this.activeIndex < this.menuList.length - 1)) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (offset <= -300 && this.activeIndex > 0) {
        this.$refs.carousel.prev();
        this.__wheelDeltaStart = 0;
      } else if (offset >= 300 && this.activeIndex < this.menuList.length - 1) {
        this.$refs.carousel.next();
        this.__wheelDeltaStart = 0;
      } else if (offset <= -300 || offset >= 300) {
        this.__wheelDeltaStart = 0;
      } else {
        this.__timeout = setTimeout(() => {
          this.__wheelDeltaStart = 0;
        }, 300);
      }
    },
  },
});
</script>
